<template>
  <div></div>
</template>

<script>
import auth from '../auth'

export default {
  name: 'Silent',
  created () {
    auth.loginSilentCallback()
  }
}
</script>
